






	// @ts-ignore
    import _ from './dev.ts'; export default _;
